import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { EASE } from "@/lib/motion";

export default function Placeholder({ audience, title, subtitle }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid="placeholder-page"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center"
    >
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(212,175,55,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.5) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative z-10 max-w-2xl"
      >
        <p className="overline mb-6">{audience}</p>
        <h1 className="font-serif text-5xl md:text-7xl font-light leading-[0.95] tracking-tighter text-[#F8F8F6]">
          {title}
        </h1>
        <p className="mx-auto mt-8 max-w-lg text-lg leading-relaxed text-[#A1A1A0]">
          {subtitle}
        </p>
        <button
          data-testid="placeholder-back-btn"
          onClick={() => navigate("/")}
          className="group mt-12 inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-3.5 text-sm text-[#F8F8F6] transition-colors duration-300 hover:border-gold hover:text-gold"
        >
          <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
          Back to Book Away
        </button>
      </motion.div>
    </div>
  );
}
